import { render, staticRenderFns } from "./ContratoPropostaModal.vue?vue&type=template&id=06affc96"
import script from "./ContratoPropostaModal.vue?vue&type=script&lang=js"
export * from "./ContratoPropostaModal.vue?vue&type=script&lang=js"
import style0 from "./ContratoPropostaModal.vue?vue&type=style&index=0&id=06affc96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports